import { makeStyles } from '@rbx/ui';
import styles from '../../shared/utils/styles';

const useHomePageCategoryListingCardStyles = makeStyles()((theme) => ({
  container: {
    background: theme.palette.surface[100],
    height: 360,
    cursor: 'pointer',
  },

  title: {
    margin: 16,
    ...styles.textClamp(),
  },

  image: {
    height: 194,
    width: '100%',
    objectFit: 'cover',
    marginBottom: 0,
  },

  description: {
    flex: 1,
    margin: '0 16px',
    ...styles.textClamp(3),
  },

  link: {
    margin: '8px 10px',
  },
}));

export default useHomePageCategoryListingCardStyles;
